import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
    iconPack: 'fontawesome',
    duration: 3000
})

Vue.toasted.register(
    'defaultSuccess',
    payload => !payload.mensagem ? 'Operação realidada com sucesso!' : payload.mensagem,
    { type: 'success', icon: 'check', position: 'top-center' }
)

Vue.toasted.register(
    'defaultError',
    payload => !payload.mensagem ? 'Oops.. Erro inesperado.' : payload.mensagem,
    { type : 'error', icon : 'times', position: 'top-center' }
)